import {DonationComponent} from "../donation/donation.component";
import {ChangeDetectorRef, Component, Renderer2} from "@angular/core";
import {OptionService} from "../option/option.service";
import {DonationService} from "../donation/donation.service";
import {UrlService} from "../url/url.service";
import {ShopCartService} from "../shop/shop.cart.service";
import {TranslateService} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {DecimalPipe} from "@angular/common";
import {ElementService} from "../service/element.service";
import {StripeService} from "../payment/payment.stripe.service";

declare let __twingle_products;

/**
 * Component for the donation shop that extend the existing DonationComponent and adds some steps.
 */
@Component({
    selector: 'giftshop',
    templateUrl: './giftshop.component.html',
    providers: [OptionService, DonationService, UrlService, ShopCartService, DecimalPipe]
})
export class GiftshopComponent extends DonationComponent {

    /**
     * The available screensizes we want to check for
     */
    screenSizes: any = {
        small: 0,
        medium: 540,
        large: 768,
        xlarge: 1200
    }

    /**
     * constructor
     * @param optionService
     * @param translate
     * @param donationService
     * @param http
     * @param changeDetector
     * @param urlService
     * @param renderer
     * @param decimalPipe
     * @param cartService
     * @param elementService
     * @param stripeService
     */
    constructor(protected optionService: OptionService,
                protected translate: TranslateService,
                protected donationService: DonationService,
                protected http: HttpClient,
                protected changeDetector: ChangeDetectorRef,
                protected urlService: UrlService,
                protected renderer: Renderer2,
                protected decimalPipe: DecimalPipe,
                protected cartService: ShopCartService,
                protected elementService: ElementService,
                protected stripeService: StripeService
    ) {
        super(optionService, translate, donationService, http, changeDetector, urlService, renderer, decimalPipe, elementService, stripeService);

        // set donation to the cart service to save ordered products
        this.cartService.setDonation(this.donation);
    }

    /**
     * @inheritDoc
     */
    ngOnInit(): any {
        super.ngOnInit();

        // we have no "start" step, show the list
        if(this.step === "start") {
            this.step = "list";
        }

        // set donation target
        const donationTargets = this.optionService.getDonationTargets();
        if(donationTargets.length > 0 && !this.donation.target) {
            // case 1: no target in donation presettet, use the first in the list
            this.donation.target = donationTargets[0].donation_target;
        }
        else if(!this.donation.target) {
            // case 2: no target presetet and no available, use a generic one
            this.translate.get('target.default').subscribe((res: string) => {
                this.donation.target = res;
            });
        }


        // for DEV Purpose only: show the cart
        // this.cartService.addItem(__twingle_products[0], 1);
        // this.setStep('cart');
    }

}
